import { UserChangeEvent } from '../../models/user-change.event';

export class SetUserChange {
    public static readonly type = '[MessagingState] Set user change';

    constructor(public event: UserChangeEvent) { }
}
